import React, { useState } from 'react';

import {
  TopbarLink,
  MobileMenuWrapper,
  TopListsIconWrapper,
  OfficialChartsIconWrapper,
  PlaylistActivityIconWrapper,
  CompareDropdownWrapper,
  ChartsIconWrap,
  MobileMenuText,
  CaretIconWrapper,
  MobIconWrapper,
  CompareWrapper,
} from '../TopBar/TopBar.style';
import MobileCompareDropdown from './MobileCompareDropdown/MobileCompareDropdown';

import { ReactComponent as TopListsIcon } from 'icons/fire-icon-top-nav.svg';
import { ReactComponent as OfficialChartsIcon } from 'icons/official-charts-header-nav-icon.svg';
import { ReactComponent as PlaylistActivityIcon } from 'icons/icon-playlist-activity.svg';
import { ReactComponent as DSPChartsIcon } from 'icons/dsp-charts-icon.svg';
import { ReactComponent as IconCompare } from 'icons/icon-compare.svg';
import { CaretIcon } from 'components/TopicNavigation/TopicNavigation.style';

interface IMobileMenuProps {
  entityIds: any;
  entityType: any;
  topic: any;
  compareMode: any;
  entitiesById: any;
  toggleDropdown: any;
  showPlaylistActivity?: boolean;
}

const MobileMenu: React.FC<IMobileMenuProps> = (props) => {
  const {
    entityIds,
    entityType,
    topic,
    compareMode,
    entitiesById,
    toggleDropdown,
    showPlaylistActivity,
  } = props;

  const [visibleDropdown, setVisibleDropdown] = useState<boolean>(false);

  return (
    <MobileMenuWrapper
      toggleDropdown={toggleDropdown}
      data-dropdown-item="dropdownItem"
    >
      {showPlaylistActivity && (
        <PlaylistActivityIconWrapper data-pw="playlist-activity" width="100%">
          <TopbarLink to="/playlistActivity" mobileRow>
            <MobIconWrapper>
              <PlaylistActivityIcon />
            </MobIconWrapper>
            <MobileMenuText>Playlist Activity</MobileMenuText>
          </TopbarLink>
        </PlaylistActivityIconWrapper>
      )}

      <TopListsIconWrapper data-pw="top-lists" width="100%" isStatic>
        <TopbarLink to="/toplists" mobileRow>
          <MobIconWrapper>
            <TopListsIcon />
          </MobIconWrapper>
          <MobileMenuText>Top Lists</MobileMenuText>
        </TopbarLink>
      </TopListsIconWrapper>

      <CompareDropdownWrapper
        onClick={(): void => setVisibleDropdown(!visibleDropdown)}
        isOpened={visibleDropdown}
      >
        <CompareWrapper>
          <MobIconWrapper width="35px" height="20px">
            <IconCompare />
          </MobIconWrapper>
          <MobileMenuText margin="0 0 0 5px">Compare Tool</MobileMenuText>
        </CompareWrapper>
        <CaretIconWrapper>
          <CaretIcon isPointingUp={visibleDropdown} />
        </CaretIconWrapper>
      </CompareDropdownWrapper>

      {visibleDropdown && (
        <MobileCompareDropdown
          toggleDropdown={(): void => setVisibleDropdown(!visibleDropdown)}
          isOpen={visibleDropdown}
          entityIds={entityIds}
          entityType={entityType}
          topic={topic}
          compareMode={compareMode}
          entitiesById={entitiesById}
          withoutPadding
        />
      )}

      <OfficialChartsIconWrapper data-pw="official" width="100%" isStatic>
        <TopbarLink to="/chart/official" mobileRow>
          <MobIconWrapper>
            <OfficialChartsIcon />
          </MobIconWrapper>
          <MobileMenuText>Official Charts</MobileMenuText>
        </TopbarLink>
      </OfficialChartsIconWrapper>

      <ChartsIconWrap data-pw="dsp" width="100%">
        <TopbarLink to="/chart/dsp" mobileRow>
          <MobIconWrapper>
            <DSPChartsIcon />
          </MobIconWrapper>
          <MobileMenuText>DSP Charts</MobileMenuText>
        </TopbarLink>
      </ChartsIconWrap>
    </MobileMenuWrapper>
  );
};

export default MobileMenu;
